// Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'

import {
  default as InboundMessage
} from './InboundMessage'

import {
  default as OutboundMessage
} from './OutboundMessage'

import { readablePhoneNumber } from '../../utils'


export class MessageList extends React.PureComponent {
  static propTypes = {
    messages: PropTypes.arrayOf(PropTypes.object).isRequired,
    selectedMessage: PropTypes.string.isRequired,
    onMessageClick: PropTypes.func.isRequired,
    scrollIntoView: PropTypes.func.isRequired,
    onMounted: PropTypes.func.isRequired,
    refs: PropTypes.object.isRequired
  }

  static defaultProps = {
    className: ''
  }

  componentDidMount() {
    if (this.props.onMounted) {
      this.props.onMounted()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedMessage !== this.props.selectedMessage) {
      this.props.scrollIntoView(this.props.selectedMessage, this.props.refs)
    }
  }

  render() {
    let { messages, selectedMessage, refs, onMessageClick, className } = this.props

    return (
      <ul className={`chat-list ${className}`}>
        {messages.map(message => {
          let selected = selectedMessage === message.id
          if (message.direction === 'INBOUND') {
            return (
              <InboundMessage
                type={message.messageType}
                fromIdentityName={message.fromIdentity
                  ? `${message.fromIdentity.fullName} (${readablePhoneNumber(message.fromWaId)})`
                  : `Unknown (${readablePhoneNumber(message.fromWaId)})`
                }
                createdAt={message.createdAt}
                body={message.body}
                selected={selected}
                onClick={() => onMessageClick(message.id)}
                key={message.id}
                ref={refs[message.id]}
              />
            )
          } else {  // OUTBOUND
            return (
              <OutboundMessage
                type={message.messageType}
                createdAt={message.createdAt}
                body={message.body}
                status={message.status}
                selected={selected}
                onClick={() => onMessageClick(message.id)}
                key={message.id}
                ref={refs[message.id]}
              />
            )
          }
        })}
      </ul>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/whatsapp-related-messages-list/MessageList.js